import * as React from 'react';
import { IconTrigger } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useDeliveryIndicator } from '../../../contexts/DeliveryIndicator/context.js';
import { DeliveryIndicatorModal } from '../components/DeliveryIndicatorModal.js';

const DeliveryIndicatorModalContainer = ()=>{
    const { deliveryInfo  } = useDeliveryIndicator();
    const { getLabel  } = useIntl();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const onModalOpen = React.useCallback(()=>{
        setIsModalOpen(true);
    }, [
        setIsModalOpen
    ]);
    const onModalClose = React.useCallback(()=>setIsModalOpen(false)
    , [
        setIsModalOpen
    ]);
    if (!deliveryInfo) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconTrigger, {
        onClick: onModalOpen,
        name: "learn-more",
        "aria-label": getLabel('products.screenreader.deliveryIndicatorModalToggle', {
            hideLabelKey: true
        })
    }), /*#__PURE__*/ React.createElement(DeliveryIndicatorModal, {
        deliveryInfo: deliveryInfo,
        isModalOpen: isModalOpen,
        onModalClose: onModalClose
    }));
};

export { DeliveryIndicatorModalContainer };
//# sourceMappingURL=DeliveryIndicatorModal.js.map
